import { Tabs } from 'antd';
import SpendVisuals from './spendVisuals/SpendVisuals';
import constants from '../../constants/constants';
import SpendData from './spendData/SpendData';
import CostPerAppHire from './costPerAppHire/CostPerAppHire';
import Suppliers from './suppliers/Suppliers';
import Market from './market/Market';
import { trackPageAccess } from '../../globalFunctions/GlobalFunctions';
import { useContext, useEffect } from 'react';
import { CommonContext } from '../../Context';

const tabItems = [
  {
    key: "1",
    label: <span>{constants.JobsAppsSpendVisuals}</span>,
    children: <SpendVisuals />,
  },
  {
    key: "2",
    label: <span>{constants.JobsAppsSpendData}</span>,
    children: <SpendData />,
  },
  {
    key: "3",
    label: <span>{constants.CostPerAppHire}</span>,
    children: <CostPerAppHire />,
  },
  {
    key: "4",
    label: <span>{constants.Suppliers}</span>,
    children: <Suppliers />,
  },
  {
    key: "5",
    label: <span>{constants.Market}</span>,
    children: <Market />,
  },
];
const NewDashboard = () => {
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
  useEffect(() => {
    trackPageAccess(buyerId,window.location.href)
  }, []);
  return (
    <div>
      <Tabs
        defaultActiveKey="1"
        destroyOnHidden
        items={tabItems}
      />
    </div>
  );
};
export default NewDashboard;
